export const hostname = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : 'https://ca.elan.org.in';

export const mainsite = `${hostname}/mainsite`;

export const contactDetailEndpoint = `${mainsite}/newContactDetail/`;
export const registrationEndpoint = `${mainsite}/newRegistration/`;